import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import Calendar from 'react-calendar';
import { FiMoreHorizontal } from 'react-icons/fi';
import { EmptyState } from '@/components/custom/empty-state';
import { Dropdown } from '@/components/custom/dropdown/dropdown';
import bannerEvento from '@/assets/images/placeholders/banner-evento.png';
import usePermission from '@/hooks/usePermission';
import usePlayfulStudent from '@/hooks/usePlayfulStudent';
import { useNavigate } from 'react-router-dom';
import { LiveClassSidebarCard } from './live-class-sidebar-card';
import { PlayfulCalendarEventCard } from './playful-calendar-event-card';
import './events-calendar.react-calendar.sass';

function EventsCalendar({
  eventsToday,
  selectedDate,
  setSelectedDate,
  onActiveStartDateChange,
  eventDates,
  visibleEvents,
  setVisibleEvents,
  hasMoreEvents,
  editEvent,
  confirmDeleteEvent,
  setShowFormEvent,
  setEditingLiveClass,
  setShowLiveClassForm,
  setCurrentLive,
  setLiveClassrooms
}) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const currentDate = moment();
  const isPlayfulStudentTheme = usePlayfulStudent();

  const handleShowMore = () => {
    setVisibleEvents(eventsToday.length);
  };

  return (
    <div className={`react-calendar-wrapper ${isPlayfulStudentTheme ? 'react-calendar-wrapper--playful' : ''}`}>
      <Calendar
        className="mx-auto"
        onChange={setSelectedDate}
        value={selectedDate}
        minDetail="month"
        maxDetail="month"
        onActiveStartDateChange={onActiveStartDateChange}
        tileClassName={({ date }) =>
          eventDates.includes(moment(date).format('YYYY-MM-DD')) ? (currentDate.isSameOrBefore(moment(date)) || currentDate.format('YYYY-MM-DD') === moment(date).format('YYYY-MM-DD') ? 'active-item bg-red' : 'active-item bg-green') : null
        }
        locale={t('language.language')}
      />

      {usePermission('Criar eventos', 'Eventos') && (
        <button
          onClick={() => setShowFormEvent(true)}
          className="btn btn--outline btn--full"
        >
          {t('events.buttonAddEvent')}
        </button>
      )}

      {usePermission('Visualizar eventos', 'Eventos') && eventsToday.length > 0 && (
        <div className="sidebar-card-wrapper">
          {eventsToday.slice(0, visibleEvents).map((event, index) =>
            isPlayfulStudentTheme ? (
              <PlayfulCalendarEventCard
                key={index}
                event={event}
              />
            ) : event.type === 'live-classroom' ? (
              <LiveClassSidebarCard
                key={index}
                liveClass={event}
                setEditingLiveClass={setEditingLiveClass}
                setShowLiveClassForm={setShowLiveClassForm}
                setCurrentLive={setCurrentLive}
                setWeekDays={setLiveClassrooms}
              />
            ) : (
              <div
                key={index}
                className="sidebar-card"
                onClick={() => navigate(`/evento/${event.id}`)}
              >
                {usePermission('Editar eventos', 'Eventos') || usePermission('Excluir eventos', 'Eventos') ? (
                  <Dropdown>
                    <Dropdown.Toggle>
                      <FiMoreHorizontal />
                    </Dropdown.Toggle>
                    <Dropdown.Content>
                      {usePermission('Editar eventos', 'Eventos') && <Dropdown.Item onClick={() => editEvent(event)}>{t('button.edit')}</Dropdown.Item>}
                      {usePermission('Excluir eventos', 'Eventos') && <Dropdown.Item onClick={() => confirmDeleteEvent(event)}>{t('button.delete')}</Dropdown.Item>}
                    </Dropdown.Content>
                  </Dropdown>
                ) : null}

                <img
                  className="sidebar-card__img"
                  src={event.image?.url || bannerEvento}
                  alt="banner evento"
                />
                <div className="sidebar-card__body">
                  <h3 className="sidebar-card__title">
                    {event['initial-time']} - {event['end-time']}
                  </h3>
                  <p className="sidebar-card__description">{event.title}</p>
                </div>
              </div>
            )
          )}
        </div>
      )}

      {eventsToday.length > 2 && (
        <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
          <button
            type="button"
            className="btn btn--link"
            onClick={hasMoreEvents ? handleShowMore : () => setVisibleEvents(2)}
          >
            {hasMoreEvents ? 'Ver mais' : 'Ver menos'}
          </button>
        </div>
      )}

      {eventsToday.length === 0 && (
        <EmptyState
          type="date"
          title={t('emptyState.eventTitle')}
          text={t('emptyState.eventText')}
          variant="plain"
        />
      )}
    </div>
  );
}

export { EventsCalendar };
